import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"
import { NftMoleculeReatom } from "../store/nft-store.reatom"

export const useActivityItemsReatom = () => {
  const { nftActivityQueryParamsAtom } = useMolecule(NftMoleculeReatom)

  // Get query params from atom and use with TanStack Query
  const queryParams = nftActivityQueryParamsAtom()
  const nftActivityQuery = useSuspenseInfiniteQuery(queryParams)

  const queryResult = useMemo(
    () => ({
      ...nftActivityQuery,
      pages: nftActivityQuery.data.pages.map((page) => ({
        items: page.activities,
      })),
    }),
    [nftActivityQuery],
  )

  return useInfiniteTableItems(queryResult)
}
